const restHost = 'https://htg-cs.dev.e-fork.net',
  restHostBackend = 'https://htg-cs.dev.e-fork.net',
  graphQlEndpoint = '/graphql',
  drupalFormat = 'YYYY-MM-DDTHH:mm:ss',
  self = 'https://htg.dev.e-fork.net';

export { restHost, restHostBackend, graphQlEndpoint, self, drupalFormat };
